import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Success.module.css";
import logo from "../../assets/logo.png";

const Success = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const domain = (location.state as { domain?: string })?.domain || "";
  const hasRealDomain = domain && domain !== "yourdomain.com";

  const handleVisit = () => {
    if (hasRealDomain) {
      // window.open(`https://${domain}`, "_blank", "noopener noreferrer");
       navigate("/my-site")
    }
  };
  const handleDashboard = () => navigate("/login", { replace: true });

  return (
    <div className={styles.page}>
      {Array.from({ length: 14 }).map((_, i) => (
        <div key={i} className={styles.particle} style={{ left: `${10 + i * 6}%`, top: `${5 + (i % 5) * 10}%`, animationDelay: `${i * 0.15}s`, background: i % 3 === 0 ? "#2D3EC5" : i % 3 === 1 ? "#F05A22" : "#10B981" }} />
      ))}
      <div className={styles.glowBg} />
      <div className={styles.container}>
        <div className={styles.logo}><img src={logo} alt="InstantGDS" className={styles.logoImg} /></div>
        <div className={styles.card}>
          <div className={styles.iconWrapper}>
            <div className={styles.iconRipple1} />
            <div className={styles.iconRipple2} />
            <div className={styles.iconCircle}><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5"><polyline points="20,6 9,17 4,12" /></svg></div>
          </div>
          <div className={styles.headerText}>
            <h1 className={styles.title}>Your website is live! 🎉</h1>
            <p className={styles.subtitle}>Your travel booking site is now accessible to the world</p>
          </div>
          <div className={styles.domainBox}>
            <div className={styles.domainShine} />
            <div className={styles.domainInner}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2D3EC5" strokeWidth="2" className={styles.globeIcon}><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>
              <span className={styles.domainUrl}>{hasRealDomain ? `https://${domain}` : "Your domain will appear here"}</span>
            </div>
          </div>
          <div className={styles.statsRow}>
            <div className={styles.statItem}><div className={styles.statIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2D3EC5" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg></div><span className={styles.statLabel}>SSL Active</span></div>
            <div className={styles.statDivider} />
            <div className={styles.statItem}><div className={styles.statIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F05A22" strokeWidth="2"><polyline points="23,6 13.5,15.5 8.5,10.5 1,18" /><polyline points="17,6 23,6 23,12" /></svg></div><span className={styles.statLabel}>HTTPS Enforced</span></div>
            <div className={styles.statDivider} />
            <div className={styles.statItem}><div className={styles.statIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12,6 12,12 16,14" /></svg></div><span className={styles.statLabel}>Auto-Renew On</span></div>
          </div>
          <div className={styles.buttons}>
            <button className={styles.btnPrimary} onClick={handleVisit} disabled={!hasRealDomain} style={!hasRealDomain ? { opacity: 0.5, cursor: "not-allowed" } : {}}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15,3 21,3 21,9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>
              {hasRealDomain ? "Visit Website" : "No Domain Set"}
            </button>
            <button onClick={() => navigate("/my-site", { state: { domain } })} style={{ flex: 1, padding: "14px", background: "linear-gradient(135deg, #1D4ED8, #3B82F6)", color: "#fff", border: "none", borderRadius: 10, cursor: "pointer", fontWeight: 600, fontSize: 15, display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polygon points="10,8 16,12 10,16" /></svg>
              Preview My Site
            </button>
            <button onClick={handleDashboard} style={{ flex: 1, padding: "14px", background: "#F1F5F9", color: "#1E293B", border: "none", borderRadius: 10, cursor: "pointer", fontWeight: 600, fontSize: 15, display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>
              Go to Dashboard
            </button>
          </div>
        </div>
        <div className={styles.footerNote}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2D3EC5" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12,6 12,12 16,14" /></svg>
          SSL certificate will auto-renew every 90 days
        </div>
      </div>
    </div>
  );
};

export default Success;